module.exports = __webpack_public_path__ + "static/media/logo-thaihealth.15c80f83.png";